import { render, staticRenderFns } from "./Institute.vue?vue&type=template&id=f76483c8&scoped=true&"
import script from "./Institute.vue?vue&type=script&lang=js&"
export * from "./Institute.vue?vue&type=script&lang=js&"
import style0 from "./Institute.vue?vue&type=style&index=0&id=f76483c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76483c8",
  null
  
)

export default component.exports